<aside [ngClass]="{'hide-nav-menu': !navMenuOpen}">
  @if (isLoaded) {
    <div slot="header" class="search-tree--form">
      <div fxLayout="row" fxLayoutAlign="space-between start" [formGroup]="formGroup">
        <lgd-text controlName="filter" label="Search" [dense]="true" [showClearButton]="true"
          (keyup)="searchKeyUp($event)">
        </lgd-text>
        <forge-icon-button dense (click)="toggleNavPin()" class="search-tree--pin"
          [attr.aria-label]="navPinText" telemetry="Submission-Pin-Menu">
          <forge-icon [name]="navPinIcon"></forge-icon>
          <forge-tooltip aria-hidden="true" placement="bottom">
            {{navPinText}}
          </forge-tooltip>
        </forge-icon-button>
      </div>
    </div>
    <div class="search-tree--container">
      @if (busy) {
        <forge-linear-progress></forge-linear-progress>
      }
      <tree #treeMenu [dataSource]="dataSource" [filter]="filterString" [selected]="selectedNode"
        (select)="onSelect($event)">
      </tree>
    </div>
  } @else {
    <forge-skeleton form-field></forge-skeleton>
    <forge-divider></forge-divider>
    <forge-skeleton list-item></forge-skeleton>
    <forge-skeleton list-item></forge-skeleton>
    <forge-skeleton list-item></forge-skeleton>
  }

</aside>
